import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get } from '../../../inteceptor';

const initialState = {
  trend: null,
  trendLoading: false,
  trendError: null,
  details: null,
  detailsLoading: false,
  detailsError: null,
};

const slice = createSlice({
  name: 'utilityCostTrend',
  initialState,
  reducers: {
    trendRequest(state) {
      state.trendLoading = true;
      state.trendError = null;
      state.trend = null;
      state.details = null;
      state.detailsError = null;
    },
    trendSuccess(state, action) {
      state.trendLoading = false;
      state.trend = action.payload;
    },
    trendFailure(state, action) {
      state.trendLoading = false;
      state.trendError = action.payload;
    },
    clearTrend(state) {
      state.trend = null;
      state.trendError = null;
      state.trendLoading = false;
      state.details = null;
      state.detailsError = null;
      state.detailsLoading = false;
    },
    detailsRequest(state) {
      state.detailsLoading = true;
      state.detailsError = null;
      state.details = null;
    },
    detailsSuccess(state, action) {
      state.detailsLoading = false;
      state.details = action.payload;
    },
    detailsFailure(state, action) {
      state.detailsLoading = false;
      state.detailsError = action.payload;
    },
    clearDetails(state) {
      state.details = null;
      state.detailsError = null;
      state.detailsLoading = false;
    },
  },
});

export default slice.reducer;

const getErrorMessage = (error) => error?.message || error?.data?.message || 'Unable to load utility cost trend data.';

export function getUtilityBillCostTrend(params) {
  return async () => {
    dispatch(slice.actions.trendRequest());
    try {
      const response = await get('utilityBillCostTrend', params);
      if (response.status) {
        dispatch(slice.actions.trendSuccess(response.data));
      } else {
        dispatch(slice.actions.trendFailure(response.message || 'Unable to load utility cost trend data.'));
      }
    } catch (error) {
      dispatch(slice.actions.trendFailure(getErrorMessage(error)));
    }
  };
}

export function getUtilityBillCostTrendDetails(params) {
  return async () => {
    dispatch(slice.actions.detailsRequest());
    try {
      const response = await get('utilityBillCostTrendDetails', params);
      if (response.status) {
        dispatch(slice.actions.detailsSuccess(response.data));
      } else {
        dispatch(slice.actions.detailsFailure(response.message || 'Unable to load utility bill details.'));
      }
    } catch (error) {
      dispatch(slice.actions.detailsFailure(getErrorMessage(error)));
    }
  };
}

export function clearUtilityBillCostTrendDetails() {
  dispatch(slice.actions.clearDetails());
}

export function clearUtilityBillCostTrend() {
  dispatch(slice.actions.clearTrend());
}
